/** Google's CSA loader, shared by the RSoC and CSA paths. */
export const CSA_SCRIPT_SRC = "https://www.google.com/adsense/search/ads.js";

/** Queues `_googCsa` calls until `ads.js` loads. */
// prettier-ignore
export const CSA_STUB = "(function(g,o){g[o]=g[o]||function(){(g[o]['q']=g[o]['q']||[]).push(arguments)},g[o]['t']=1*new Date()})(window,'_googCsa');";
